const { cornerLineLength, panLineMargin } = specConfig;
const { trenchWallBuffer } = panManufacturingReq;

class PanBuilderBase {

    constructor( x = 0, y = 0, scale = 8) {

        this.defaults = {
            font: null,
            dashedLine: [20, 3, 5, 3],
        };

        this.state = {
            panX: x,
            panY: y,
            scale,
        };

        const bg = this._createBackground(1000, 1000);
        this.backgroundPattern = drawingContext.createPattern(bg.canvas, 'no-repeat');
    }

    scale(amount) {
        this.state.scale = amount;
    }

    splashWallWidth(amount) {
        this.state.splashWallWidthInches = amount;
    }

    curbType(type) {
        this.state.curbType = type;
    }

    curbWidth(amount) {
        this.state.curbWidthInches = amount;
    }

    curbHeight(amount) {
        this.state.curbHeightInches = amount;
    }

    grateStyle(type) {
        this.state.grateStyle = type;
    }

    dimensions(width, depth) {
        this.state.panWidthInches = +(width);
        this.state.panDepthInches = +(depth);
        this.state.aspectRatio = Math.round(width / depth, 2);
    }

    drainLocation(side, back, position) {
        this.state.drainSideDistanceInches = +(side);
        this.state.drainBackDistanceInches = +(back);
        this.state.drainPosition = position;
    }

    static _formatNumber(n) {
        return (Math.round(n * 100) / 100).toFixed(2);
    }

    static _findClosest(arr, num) {

    }

    _getTrenchSize(width) {
        this.state.trenchGrateWidthInches = trenchGrateWidths.reduce((current, previous) => {
            if (current < width && (width - current) >= trenchWallBuffer) return current;
            return previous;
        });

        return this.state.trenchGrateWidthInches;
    }

    _getTextWidth(text) {
        return Math.ceil(drawingContext.measureText(text).width);
    }

    _createTrenchGrate(size, vars) {
        const { p5, state: {
            drainPosition, scale,
        } } = this;

        const {
            panDepth, curbWidth,
            drainY, splashWallWidth,
            grateDepth,
        } = vars;

        noFill();
        stroke('black');
        strokeWeight(1);

        const grateWidthInches = this._getTrenchSize(size);
        const grateWidth = Math.round(grateWidthInches * scale);

        rect(
            -(grateDepth / 2), -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
            grateDepth, grateWidth,
        );

        let trenchX = 40;
        let trenchLineOffset = (grateDepth / 2) + panLineMargin;
        let trenchLineLength = cornerLineLength * 0.55;

        if (drainPosition === 'Right') {
            trenchX = -40;
            trenchLineOffset = -(cornerLineLength * 0.55);
            trenchLineLength = -((grateDepth / 2) + panLineMargin);
        }

        line(
            trenchLineOffset, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
            trenchLineLength, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
        );

        line(
            trenchLineOffset, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth + grateWidth) / 2)),
            trenchLineLength, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth + grateWidth) / 2)),
        );

        this._createMeasureLine(
            trenchX, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
            trenchX, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth + grateWidth) / 2)),
            grateWidthInches,
            25,
        );
    }

    _createBackTrenchGrate(size, vars) {
        const { p5, state: {
            drainPosition, scale, curbType,
        } } = this;

        const {
            panDepth, curbWidth,
            drainY, splashWallWidth,
            grateDepth, panWidth,
            drainX,
        } = vars;

        noFill();
        stroke('black');
        strokeWeight(1);

        const grateWidthInches = this._getTrenchSize(size);
        const grateWidth = Math.round(grateWidthInches * scale);
        let trenchStart = -(drainX - splashWallWidth - ((panWidth - grateWidth - (splashWallWidth * 2)) / 2));
        let trenchEnd = panWidth - drainX - splashWallWidth - ((panWidth - grateWidth - (splashWallWidth * 2)) / 2);

        if (curbType === 'Right Dual Curb') {
            trenchStart -= curbWidth / 2;
            trenchEnd -= curbWidth / 2;
        }

        if (curbType === 'Left Dual Curb') {
            trenchStart += curbWidth / 2;
            trenchEnd += curbWidth / 2;
        }

        rect(
            trenchStart,
            -(grateDepth / 2),
            grateWidth, grateDepth,
        );

        line(
            trenchStart,
            (grateDepth / 2) + panLineMargin,
            trenchStart,
            cornerLineLength * 0.55,
        );

       line(
            trenchEnd,
            (grateDepth / 2) + panLineMargin,
            trenchEnd,
            cornerLineLength * 0.55,
        );

        this._createMeasureLine(
            trenchStart,
            (grateDepth / 2) + panLineMargin + 15,
            trenchEnd,
            (grateDepth / 2) + panLineMargin + 15,
            grateWidthInches,
            25,
        );
    }

    _createMeasureLine(x1, y1, x2, y2, textValue, offset = 0) {
        const { p5, state: { drainPosition } } = this;
        const midpoint = createVector((x1 + x2) / 2, (y1 + y2) / 2);
        const lineHeight = (y1 === y2) ? 5 : 0;
        const textMarginMin = 50;

        strokeWeight(1);
        noFill();
        stroke('black');
        line(x1, y1, x2, y2);
        this._createArrows(x1, y1, x2, y2);

        if (textValue) {
            const textWidth = this._getTextWidth(textValue);
            let y = midpoint.y + lineHeight;
            let x = midpoint.x + lineHeight;

            if (x1 === x2) {
                const textMarginY = (y2 - y1) - textWidth;

                if (textMarginY <= textMarginMin) {
                    y = y2 + textMarginMin;

                    strokeWeight(1);
                    line(x2, y2, x2, y2 + textMarginMin/3);
                }

                push();
                translate(midpoint.x, y);
                rotate(-HALF_PI);

                this._createText(
                    textValue,
                    textMarginMin/4 + offset, 5,
                );

                pop();
            } else if (y1 === y2) {
                const textMarginX = (x2 - x1) - textWidth;

                if (textMarginX <= textMarginMin) {
                    strokeWeight(1);

                    if (drainPosition === 'Left') {
                        x = x1 + textMarginMin + 50;

                        line(x1, y2, x1 + 70, y2);
                    } else {
                        x = -(x1 + textMarginMin);
                        line(x1 - textMarginMin, y2, x1, y2);
                    }
                }

                this._createText(
                    textValue,
                    x,
                    midpoint.y + lineHeight,
                );
            }
        }
    }

    _createArrow(x, y, direction, arrowHeight = 10, arrowWidth = 3, leadLine = true) {
        const { p5 } = this;

        strokeWeight(0);
        fill(0);

        if (direction === 'up') {
            triangle(
                x, y - arrowHeight,
                x + arrowWidth, y,
                x - arrowWidth, y,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x, y + arrowHeight);
            strokeWeight(0);
        }

        if (direction === 'down') {
            triangle(
                x, y + arrowHeight,
                x + arrowWidth, y,
                x - arrowWidth, y,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x, y - arrowHeight);
            strokeWeight(0);
        }

        if (direction === 'left') {
            triangle(
                x - arrowHeight, y,
                x, y + arrowWidth,
                x, y - arrowWidth,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x + arrowHeight, y);
            strokeWeight(0);
        }

        if (direction === 'right') {
            triangle(
                x + arrowHeight, y,
                x, y + arrowWidth,
                x, y - arrowWidth,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x - arrowHeight, y);
            strokeWeight(0);
        }
    }

    _createArrows(x1, y1, x2, y2) {
        const arrowHeight = 5;

        // Vertical
        if (x1 === x2) {
            if (y1 < y2) {
                this._createArrow(x1, y1 + arrowHeight, 'up', arrowHeight);
                this._createArrow(x2, y2 - arrowHeight, 'down', arrowHeight);
            } else {
                this._createArrow(x1, y1 - arrowHeight, 'down', arrowHeight);
                this._createArrow(x2, y2 + arrowHeight, 'up', arrowHeight);
            }
        }

        // Horizontal
        if (y1 === y2) {
            if (x1 < x2) {
                this._createArrow(x1 + arrowHeight, y1, 'left', arrowHeight);
                this._createArrow(x2 - arrowHeight, y2, 'right', arrowHeight);
            } else {
                this._createArrow(x1 - arrowHeight, y1, 'right', arrowHeight);
                this._createArrow(x2 + arrowHeight, y2, 'left', arrowHeight);
            }
        }
    }

    _createText(textValue, x, y, renderMatte = true) {
        const { p5, constructor: { _formatNumber } } = this;
        const formatedText = _formatNumber(textValue);
        const renderedText = drawingContext.measureText(formatedText);
        const txtWidth = Math.ceil(renderedText.width);
        const textHeight = Math.ceil(renderedText.actualBoundingBoxAscent);
        const padding = 2;

        strokeWeight(0);

        if (renderMatte) {
            fill('white');

            rect(
                x - (txtWidth / 2) - padding, y - textHeight - padding,
                txtWidth + (padding * 2), textHeight + (padding * 2),
            );
        }

        fill(0);
        text(formatedText, x - (renderedText.width / 2), y);
    }

    _createLine(verts, weight = 1, arrows = true, arrowSize = 25) {
        const { orgX, orgY, destX, destY } = verts;

        this.strokeWeight(weight);
        this.line(orgX, orgY, destX, destY);

        if (arrows) {
            this._createArrows(verts);
        }
    }

    _createBackground(width, height, lineSpacing = 3.5) {
        const { p5 } = this;
        const bg = createGraphics(width, height);

        bg.pixelDensity(2);
        bg.strokeWeight(0.5);
        bg.noFill();
        bg.stroke(0);

        let x = 0;
        let y = height;

        while (y >= 0) {
            bg.line(x, y, y, 0);
            y -= lineSpacing;
        }

        x = 0;
        y = height;

        while (x <= width) {
            bg.line(x, width, width, x);
            x += lineSpacing;
        }

        return bg;
    }

    _getDrainRenderPalette() {
        if (globalThis.RYW_DRAIN_DEBUG_COLORS === true) {
            return {
                debug: true,
                insert: { fill: '#f97316', stroke: '#9a3412' },
                panMaterial: {
                    fill: 'rgba(96, 165, 250, 0.25)',
                    stroke: '#1d4ed8',
                },
                annotation: '#111827',
            };
        }

        return {
            debug: false,
            insert: { fill: 'black', stroke: 'black' },
            panMaterial: { fill: 'white', stroke: 'black' },
            annotation: 'black',
        };
    }

    _drawDrainProfilePolygon(graphic, points, part, fillPattern = null) {
        const context = graphic.drawingContext;

        context.save();
        context.beginPath();
        context.moveTo(points[0][0], points[0][1]);

        points.slice(1).forEach(([x, y]) => context.lineTo(x, y));

        context.closePath();
        context.fillStyle = fillPattern || part.fill;
        context.fill();

        if (part.stroke) {
            context.strokeStyle = part.stroke;
            context.lineWidth = 1;
            context.stroke();
        }

        context.restore();
    }

    _drawDrainProfilePolyline(graphic, points, strokeColor) {
        const context = graphic.drawingContext;

        context.save();
        context.beginPath();
        context.moveTo(points[0][0], points[0][1]);
        points.slice(1).forEach(([x, y]) => context.lineTo(x, y));
        context.strokeStyle = strokeColor;
        context.lineWidth = 1;
        context.stroke();
        context.restore();
    }

    _getCompressionDrainContactProfile({
        flangeHalf, bodyHalf, topDepth, flangeBottom, bottomDepth,
        threadBottomClearance = 0,
    }) {
        const { state: { scale } } = this;
        const threadBottom = Math.max(
            flangeBottom,
            bottomDepth - threadBottomClearance,
        );
        const threadRun = Math.max(0, threadBottom - flangeBottom);
        const threadCount = Math.max(1, Math.round(threadRun / (0.25 * scale)));
        const threadPitch = threadRun / threadCount;
        const threadDepth = Math.min(
            (flangeHalf - bodyHalf) * 0.35,
            0.16 * scale,
        );
        const points = [
            [-flangeHalf, topDepth],
            [-flangeHalf, flangeBottom],
            [-bodyHalf, flangeBottom],
        ];

        for (let index = 0; index < threadCount; index += 1) {
            const threadTop = flangeBottom + (index * threadPitch);

            points.push(
                [-bodyHalf - threadDepth, threadTop + (threadPitch * 0.30)],
                [-bodyHalf - threadDepth, threadTop + (threadPitch * 0.43)],
                [-bodyHalf, threadTop + (threadPitch * 0.74)],
                [-bodyHalf, threadTop + threadPitch],
            );
        }

        if (threadBottom < bottomDepth) {
            points.push([-bodyHalf, bottomDepth]);
        }

        return points;
    }

    _trimDrainContactProfile(profile, startDepth) {
        const firstPointAfterStart = profile.findIndex(([, pointDepth]) => (
            pointDepth > startDepth
        ));

        if (firstPointAfterStart < 0) {
            return [[profile[profile.length - 1][0], startDepth]];
        }

        const nextPoint = profile[firstPointAfterStart];
        const previousPoint = profile[firstPointAfterStart - 1] || nextPoint;
        const depthRun = nextPoint[1] - previousPoint[1];
        const progress = depthRun === 0
            ? 1
            : (startDepth - previousPoint[1]) / depthRun;
        const startOffset = previousPoint[0]
            + ((nextPoint[0] - previousPoint[0]) * progress);

        return [
            [startOffset, startDepth],
            ...profile.slice(firstPointAfterStart),
        ];
    }

    _cutCompressionDrainPocket(graphic, {
        axis, center, surface, bottom, depth, panVariant, trenchSection,
    }) {
        const { state: { scale } } = this;
        const palette = this._getDrainRenderPalette();
        const outsetWidth = panVariant === 'plank'
            ? compressionDrainSpec.basePanOutsetWidth
            : compressionDrainSpec.panOutsetWidth;
        const outsetHalf = (outsetWidth * scale) / 2;
        const flangeHalf = (compressionDrainSpec.insertFlangeWidth * scale) / 2;
        const bodyHalf = (compressionDrainSpec.insertBodyWidth * scale) / 2;
        const collarWidth = 0.5 * scale;
        const flangeDepth = (
            panVariant === 'plank'
                ? compressionDrainSpec.baseInsertFlangeDepth
                : compressionDrainSpec.insertFlangeDepth
        ) * scale;
        const threadBottomClearance = (
            compressionDrainSpec.threadBottomClearance * scale
        );
        const panBottomDepth = bottom - surface;
        const profileDepth = Math.max(depth, panBottomDepth);
        const lowerOutsetHalf = bodyHalf + collarWidth;
        const baseStepDepth = panBottomDepth
            + ((profileDepth - panBottomDepth) * 0.3);
        const isAlongTrench = panVariant === 'trench'
            && trenchSection === 'along';
        const leftContactProfile = this._getCompressionDrainContactProfile({
            flangeHalf,
            bodyHalf,
            topDepth: 0,
            flangeBottom: flangeDepth,
            bottomDepth: profileDepth,
            threadBottomClearance,
        });
        const leftLowerContactProfile = this._trimDrainContactProfile(
            leftContactProfile,
            panBottomDepth,
        );
        const rightContactProfile = leftContactProfile.map(([offset, pointDepth]) => [
            -offset, pointDepth,
        ]);
        const eraseProfile = isAlongTrench
            ? [
                [-outsetHalf, 0],
                [-outsetHalf, profileDepth],
                [outsetHalf, profileDepth],
                [outsetHalf, 0],
            ]
            : [
                ...leftContactProfile,
                ...rightContactProfile.slice().reverse(),
            ];
        const mapPoint = ([offset, pointDepth]) => axis === 'side'
            ? [surface + pointDepth, center + offset]
            : [center + offset, surface + pointDepth];
        const mappedEraseProfile = eraseProfile.map(mapPoint);
        const context = graphic.drawingContext;

        // Cut the stepped opening through the existing pan body. Because this is
        // done on the pan graphics itself, the surrounding hatch stays continuous.
        context.save();
        context.globalCompositeOperation = 'destination-out';
        context.fillStyle = '#000000';
        context.beginPath();
        context.moveTo(mappedEraseProfile[0][0], mappedEraseProfile[0][1]);
        mappedEraseProfile.slice(1).forEach(([x, y]) => context.lineTo(x, y));
        context.closePath();
        context.fill();
        context.restore();

        const leftOutset = isAlongTrench
            ? [
                [-outsetHalf, 0],
                [-outsetHalf, profileDepth],
                ...leftContactProfile.slice().reverse(),
            ]
            : panVariant === 'trench'
            ? [
                [-outsetHalf, panBottomDepth],
                [-outsetHalf, profileDepth],
                ...leftLowerContactProfile.slice().reverse(),
            ]
            : [
                [-outsetHalf, panBottomDepth],
                [-outsetHalf, baseStepDepth],
                [-lowerOutsetHalf, baseStepDepth],
                [-lowerOutsetHalf, profileDepth],
                ...leftLowerContactProfile.slice().reverse(),
            ];
        const rightOutset = leftOutset.map(([offset, pointDepth]) => [
            -offset, pointDepth,
        ]);
        const leftOutsetPolygon = leftOutset.map(mapPoint);
        const rightOutsetPolygon = rightOutset.map(mapPoint);

        // Rebuild the along-trench collar from the trench bottom. Other section
        // collars add material only below the original pan bottom. Every deepest
        // ledge terminates directly against the insert.
        this._drawDrainProfilePolygon(
            graphic,
            leftOutsetPolygon,
            { fill: 'white', stroke: null },
            this.backgroundPattern,
        );
        this._drawDrainProfilePolygon(
            graphic,
            rightOutsetPolygon,
            { fill: 'white', stroke: null },
            this.backgroundPattern,
        );

        // Remove the old pan-bottom outline across the attachment area, then
        // restore only the hatch. The outset must read as one piece with the pan.
        const attachmentSegments = [
            [[-outsetHalf, panBottomDepth], [-bodyHalf, panBottomDepth]],
            [[bodyHalf, panBottomDepth], [outsetHalf, panBottomDepth]],
        ].map(segment => segment.map(mapPoint));

        context.save();
        context.globalCompositeOperation = 'destination-out';
        context.strokeStyle = '#000000';
        context.lineWidth = 2;
        context.beginPath();
        attachmentSegments.forEach(([[x1, y1], [x2, y2]]) => {
            context.moveTo(x1, y1);
            context.lineTo(x2, y2);
        });
        context.stroke();
        context.restore();

        context.save();
        context.strokeStyle = this.backgroundPattern;
        context.lineWidth = 2;
        context.beginPath();
        attachmentSegments.forEach(([[x1, y1], [x2, y2]]) => {
            context.moveTo(x1, y1);
            context.lineTo(x2, y2);
        });
        context.stroke();
        context.restore();

        if (palette.debug) {
            this._drawDrainProfilePolygon(
                graphic,
                leftOutsetPolygon,
                { fill: palette.panMaterial.fill, stroke: null },
            );
            this._drawDrainProfilePolygon(
                graphic,
                rightOutsetPolygon,
                { fill: palette.panMaterial.fill, stroke: null },
            );
        }

        const contourColor = palette.debug
            ? palette.panMaterial.stroke
            : 'black';

        const exposedPointCount = panVariant === 'plank' ? 5 : 3;
        const contourOverlap = Math.max(2, scale * 0.15);
        const hasSeparateJunctions = panVariant === 'trench';
        const leftExposedContour = (
            hasSeparateJunctions
                ? [
                    [leftOutset[0][0], panBottomDepth + 1],
                    ...leftOutset.slice(1, exposedPointCount),
                ]
                : [
                    [-outsetHalf - contourOverlap, panBottomDepth],
                    ...leftOutset.slice(0, exposedPointCount),
                ]
        ).map(mapPoint);
        const rightExposedContour = (
            hasSeparateJunctions
                ? [
                    [rightOutset[0][0], panBottomDepth + 1],
                    ...rightOutset.slice(1, exposedPointCount),
                ]
                : [
                    [outsetHalf + contourOverlap, panBottomDepth],
                    ...rightOutset.slice(0, exposedPointCount),
                ]
        ).map(mapPoint);

        this._drawDrainProfilePolyline(
            graphic, leftExposedContour, contourColor,
        );
        this._drawDrainProfilePolyline(
            graphic, rightExposedContour, contourColor,
        );
    }

    _createDrain(vars) {
        return this._createCompressionDrain(vars, 'plank');
    }

    _createTrenchDrain(vars) {
        return this._createCompressionDrain(vars, 'trench');
    }

    _createCompressionDrain(vars, panVariant) {
        const { state: { scale } } = this;
        const {
            drainWidth, drainHeight, drainInnerDiameter, vLine,
        } = vars;
        const bg = createGraphics(100, 100);
        const palette = this._getDrainRenderPalette();
        const centerX = drainWidth / 2;
        // Trench section call sites position the 100px drain graphic three
        // pixels above the trench-floor datum. Offset the complete insert
        // profile by the same amount so every contact edge stays aligned.
        const totalDepth = drainHeight;
        const outsetHalf = (compressionDrainSpec.panOutsetWidth * scale) / 2;
        const flangeHalf = (compressionDrainSpec.insertFlangeWidth * scale) / 2;
        const bodyHalf = (compressionDrainSpec.insertBodyWidth * scale) / 2;
        const boreHalf = drainInnerDiameter / 2;
        const flangeDepth = (
            panVariant === 'plank'
                ? compressionDrainSpec.baseInsertFlangeDepth
                : compressionDrainSpec.insertFlangeDepth
        ) * scale;
        const threadBottomClearance = (
            compressionDrainSpec.threadBottomClearance * scale
        );
        const topOffset = panVariant === 'trench' ? 3 : 0;
        const flangeBottom = topOffset + flangeDepth;
        const insertBottom = topOffset + totalDepth;

        bg.translate(10, 10);

        // Draw the plastic CD mold insert as two section walls and leave the
        // bore open. The outer profile includes the fine contact threads.
        const leftOuterProfile = this._getCompressionDrainContactProfile({
            flangeHalf,
            bodyHalf,
            topDepth: topOffset,
            flangeBottom,
            bottomDepth: insertBottom,
            threadBottomClearance,
        });
        const leftInsertWall = [
            [centerX - boreHalf, topOffset],
            [centerX - boreHalf, insertBottom],
            ...leftOuterProfile.slice().reverse().map(([offset, pointDepth]) => [
                centerX + offset,
                pointDepth,
            ]),
        ];
        const rightInsertWall = leftInsertWall.map(([x, y]) => [
            centerX + (centerX - x),
            y,
        ]).reverse();

        this._drawDrainProfilePolygon(bg, leftInsertWall, palette.insert);
        this._drawDrainProfilePolygon(bg, rightInsertWall, palette.insert);

        // Keep the molded insert's top edge level across the drain opening.
        bg.stroke(palette.insert.fill);
        bg.strokeWeight(1);
        bg.line(
            centerX - flangeHalf, topOffset,
            centerX + flangeHalf, topOffset,
        );

        bg.stroke(palette.annotation);
        bg.strokeWeight(1);
        bg.line(centerX, topOffset - 3, centerX, insertBottom + 3);

        // Extension lines for the six-inch pan-outset dimension.
        bg.line(
            centerX - outsetHalf,
            insertBottom,
            centerX - outsetHalf,
            insertBottom + vLine,
        );
        bg.line(
            centerX + outsetHalf,
            insertBottom,
            centerX + outsetHalf,
            insertBottom + vLine,
        );

        return bg;
    }

}
